<template>
  <div class="nuc">
    <c_Nav :Index="Index" :city-code="cityCode"></c_Nav>
    <c_NewMessage></c_NewMessage>
    <!--内容  star-->
    <div class="scdMain">
      <div class="secondMainTitle">
        <i></i>
        <span>联系我们</span>
      </div>
      <!--切换开关  star-->
      <div class="ncuSwitch">
        <ul class="clearfix">
          <!--<li @click="contact" :class="contactUs ? 'ncuSwitchBg' : 'ncuSwitchFalse'">联系我们</li>-->
          <!--<li @click="about" :class="aboutUs ? 'ncuSwitchBg' : 'ncuSwitchFalse'">关于我们</li>-->
          <li @click="contact" :class="{'ncuSwitchBg':contactUs}">联系我们</li>
          <li @click="about" :class="{'ncuSwitchBg':aboutUs}">关于我们</li>
        </ul>
      </div>
      <!--切换开关  end-->
      <!--联系我们  star-->
      <div class="cuMain" v-if="contactUs">
          <!--<h5>{{publicData.CompanyName}}</h5>-->
          <!--<h5>天津润通泽商贸有限公司</h5>-->
          <!--<div class="title">Guangzhou Jing Yue Automobile Leasing Co., Ltd</div>-->
          <!--<div class="text">-->
            <!--<ul>-->
              <!--<template v-for="item in publicData.ContactInfo">-->
                <!--<li><span>联系人：</span><span>{{item.Name}}</span><span></span></li>-->
                <!--<li><span>电话：</span><span>{{item.Phone}}</span><span></span></li>-->
              <!--</template>-->
              <!--<li><span>固话：</span><span>022-45496314</span></li>-->
              <!--&lt;!&ndash;<li><span>传真：</span><span></span></li>&ndash;&gt;-->
              <!--<li><span>邮箱：</span><span>{{publicData.EMail}}</span></li>-->
              <!--&lt;!&ndash;<li><span>网址：</span><span></span></li>&ndash;&gt;-->
              <!--<li><span>地址：</span><span>天津市南开区咸阳路91号4号车间0308室</span></li>-->
              <!--&lt;!&ndash;<li><span>备注：</span></li>&ndash;&gt;-->
            <!--</ul>-->
          <!--</div>-->
        <div v-html="cuData"></div>
          <c_Map v-if="publicData.Addr" :public-data="publicData"></c_Map>
      </div>
      <!--联系我们  end-->
      <!--关于我们  star-->
      <!--<div class="aboutUs" v-if="aboutUs">-->
        <!--<p>我公司（福建旅车汇旅游客运有限公司）租赁车辆车型种类丰富，可满足客户带司机包车及自驾租车不同的用车需求，我们车型有：考斯特、丰田海狮、奔驰威霆、别克GL8、丰田埃尔法等7至18座各款商务车型，有金龙金旅宇通19至57座各品牌大小中巴，小轿车配备有：加长林肯、加长凯迪拉克、加长悍马、劳斯莱斯幻影、 奔驰、宝马、奥迪A6L、别克、凯美瑞、广本、帕萨特、伊兰特、瑞风、捷达等一系列各种类型不同档次的车辆。</p>-->
        <!--<p>公司主要以社会各界需要租用汽车的团体、个人、企事业单位、酒店、旅游公司为服务对象，根据客户选配车型，并有多种租赁方式供客户选择：带司机包车、自驾租车、长短租、机场接送、宾馆接送、商务用车、明星接待、会议租车、婚礼花车，旅游包车，公司上下班接送，公司配备专业驾驶员，司机资历深厚，熟悉本地城市道路情况，并配备通信联络工具，经过培训具有较强的服务意识、保密意识、是各企业单位拓展的好帮手。</p>-->
        <!--<p> 选择我们的理由：</p>-->
        <!--<p>第一：完善的会员服务，贴心的增值服务</p>-->
        <!--<p>我们的顾客可享受到更快捷的租车预订、更优惠的租车价格、提供更多的出行配套服务。</p>-->
        <!--<p>第二：全面完整的保险计划 </p>-->
        <!--<p>我们提供了全面完整的保险方案，使客户在没有任何负担下租车。签约客户在租车期间，将享受已生效的全面保险权益。同时还提供快捷的后台支持系统，第一时间实施救援、事故处理的紧急预案，为客户提供最安全周到的服务。</p>-->
        <!--<p>第三：完善的预订、结算系统</p>-->
        <!--<p>我们的客户可通过电话预订、现场预订等多种方式，轻松完成下订单及费用结算，为出行异地的客户提供最快捷、最安全的支付手段。 </p>-->
        <!--<p>第四：多种车型，良好车况，满足各类客户需求 我们配备有多种全新自动挡车型，全方位满足各种客户的出行需求；所备车辆每两年更换一次，并建立了严格地保障体系，保证每一辆车车况良好，让客户100%安全新的服务理念：根据顾客的实际需要订做各种“租车套餐”包括公务、商务、旅游等；当车辆出现故障时，同级车辆替换，保证满足顾客的租车需求；送车上门服务，顾客在家里就可以租到满意的车辆。</p>-->
      <!--</div>-->
      <div class="aboutUs" v-if="aboutUs">{{publicData.BackTxt}}</div>
      <!--关于我们  end-->


    </div>
    <!--内容  end-->

  </div>
</template>

<script>
  import c_Nav from '@/components/Nav/Nav'
  import c_NewMessage from '@/components/NewMessage/NewMessage'
  import c_Map from '@/components/Map/Map'
  export default {
    name: 'NavContactUs',
    props:['publicData','cityCode'],
    components:{c_Nav,c_NewMessage,c_Map},
    data () {
      return {
        Index:6,
        contactUs:true,
        aboutUs:false,
        cuData:'',
        mapStatus:false,
      }
    },
    mounted(){
      this.getContactUsData();
    },
    methods:{
      contact(){
        this.contactUs = true;
        this.aboutUs = false;
      },
      about(){
        this.contactUs = false;
        this.aboutUs = true;
      },
      getContactUsData:function () {
        var that = this;
        this.axios.get('RelateMeInfo',{
          params:{}
        }).then(function (res) {
          console.log(res);
          that.cuData = res.data.data.ContactMe;
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .clear {overflow: hidden;}
  .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

  .scdMain{width: 702px;margin: 0 auto 20px;}

  /*标题  star*/
  .secondMainTitle{height: 90px;border-bottom: 2px dashed #9fb0c0;text-align: left}
  .secondMainTitle i{width: 8px;height: 36px;background: #1dd2af;display: inline-block;text-align: left;margin-top: 44px;}
  .secondMainTitle span{height:44px;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(44,62,80,1);margin: 0 0 0 14px;display:inline-block}
  /*标题  end*/

  .ncuSwitch{margin: 16px 0 40px 0}
  .ncuSwitch ul li{width: 168px;height: 48px;text-align: center;line-height: 48px;background: #eee;color: #2c3e50;margin-right: 10px;float: left;font-size: 24px}

  .ncuSwitchBg{background: #1dd2af!important;color: #ffffff!important;}

  /*联系我们  star*/
  .cuMain h5{font-size:40px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(44,62,80,1);margin: 40px 0 4px 0;text-align: left}
  .title{font-size:24px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(44,62,80,1);text-align: left}
  .text{margin: 40px 0}
  .text ul li{font-size:28px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(77,102,126,1);line-height:40px;text-align: left;margin-bottom: 10px}
  /*联系我们  end*/

  .aboutUs{box-sizing: border-box;text-align: left;}


</style>



// WEBPACK FOOTER //
// src/components/NavContactUs/NavContactUs.vue